import { PlusOutlined } from '@ant-design/icons';
import type { RadioChangeEvent } from 'antd';
import { Button, Col, Divider, Form, Radio, Row } from 'antd';
import { useEffect, useState } from 'react';
import { useFormContext } from '../../Context/DeclarationContext';
import FormColapse from '../Form_collapse';
import './third_parties_involved_form.scss';
export const ThirdPartiesInvolvedFormComponent = () => {
  const [element_form] = Form.useForm();
  const { state, dispatch } = useFormContext();
  const [radioPropertyInvolved, setRadioPropertyInvolved] = useState(state.thirdPartyInvolved?.propertyInvolved || false);
  const [radioPeopleInjured, setRadioPeopleInjured] = useState(state.thirdPartyInvolved?.peopleInjured || false);
  const [radioThirdPartyInformationAvailable, setRadioThirdPartyInformationAvailable] = useState(
    state.thirdPartyInvolved?.thirdPartyInformationAvailable || false
  );
  const [thirdPartyInvolvedInformation, setThirdPartyInvolvedInformation] = useState<any>(
    state.thirdPartyInvolved?.thirdPartyInvolvedInformation || []
  );

  useEffect(() => {
    dispatch({
      type: 'UPDATE_CURRENT_FORM_ELEMENT',
      payload: element_form,
    });
  }, [state.step]);

  useEffect(() => {
    element_form.setFieldsValue({
      propertyInvolved: radioPropertyInvolved,
      peopleInjured: radioPeopleInjured,
      thirdPartyInformationAvailable: radioThirdPartyInformationAvailable,
    });
  }, []);

  useEffect(() => {
    setRadioPropertyInvolved(state.thirdPartyInvolved?.propertyInvolved || false);
    setRadioPeopleInjured(state.thirdPartyInvolved?.peopleInjured || false);
    setRadioThirdPartyInformationAvailable(state.thirdPartyInvolved?.thirdPartyInformationAvailable || false);

    element_form.setFieldsValue({
      propertyInvolved: state.thirdPartyInvolved?.propertyInvolved || false,
      peopleInjured: state.thirdPartyInvolved?.peopleInjured || false,
      thirdPartyInformationAvailable: state.thirdPartyInvolved?.thirdPartyInformationAvailable || false,
    });
  }, [state.thirdPartyInvolved]);

  const onChangePropertyInvolved = (e: RadioChangeEvent) => {
    if (e.target.value === true) {
      dispatch({
        type: 'UPDATE_THIRD_PARTY_INVOLVED',
        payload: {
          propertyInvolved: e.target.value,
          peopleInjured: state.thirdPartyInvolved?.peopleInjured,
          thirdPartyInformationAvailable: state.thirdPartyInvolved?.thirdPartyInformationAvailable,
          thirdPartyInvolvedInformation: state.thirdPartyInvolved?.thirdPartyInvolvedInformation,
        },
      });
    } else {
      dispatch({
        type: 'UPDATE_THIRD_PARTY_INVOLVED',
        payload: {
          propertyInvolved: e.target.value,
          peopleInjured: false,
          thirdPartyInformationAvailable: false,
          thirdPartyInvolvedInformation: state.thirdPartyInvolved?.thirdPartyInvolvedInformation,
        },
      });
    }
  };

  const onChangePeopleInjured = (e: RadioChangeEvent) => {
    dispatch({
      type: 'UPDATE_THIRD_PARTY_INVOLVED',
      payload: {
        propertyInvolved: state.thirdPartyInvolved?.propertyInvolved,
        peopleInjured: e.target.value,
        thirdPartyInformationAvailable: state.thirdPartyInvolved?.thirdPartyInformationAvailable,
        thirdPartyInvolvedInformation: state.thirdPartyInvolved?.thirdPartyInvolvedInformation,
      },
    });
  };

  const onChangeThirdPartyInformationAvailable = (e: RadioChangeEvent) => {
    dispatch({
      type: 'UPDATE_THIRD_PARTY_INVOLVED',
      payload: {
        propertyInvolved: state.thirdPartyInvolved?.propertyInvolved,
        peopleInjured: state.thirdPartyInvolved?.peopleInjured,
        thirdPartyInformationAvailable: e.target.value,
        thirdPartyInvolvedInformation: state.thirdPartyInvolved?.thirdPartyInvolvedInformation,
      },
    });
  };

  const [formCollapse, setFormCollapse] = useState(() => {
    if (state.thirdPartyInvolved?.thirdPartyInvolvedInformation?.length) {
      return state.thirdPartyInvolved?.thirdPartyInvolvedInformation?.map((item, index) => {
        return (
          <FormColapse
            key={index}
            indicador={index}
            thirdPartyInvolvedInformation={thirdPartyInvolvedInformation}
            setThirdPartyInvolvedInformation={setThirdPartyInvolvedInformation}
          />
        );
      });
    } else {
      return [
        <FormColapse
          key={0}
          indicador={0}
          thirdPartyInvolvedInformation={thirdPartyInvolvedInformation}
          setThirdPartyInvolvedInformation={setThirdPartyInvolvedInformation}
        />,
      ];
    }
  });

  useEffect(() => {
    if (thirdPartyInvolvedInformation.length > 0) {
      console.log('thirdPartyInvolvedInformation useEfect ✅✅', thirdPartyInvolvedInformation);
      dispatch({
        type: 'UPDATE_THIRD_PARTY_INVOLVED_INFORMATION',
        payload: thirdPartyInvolvedInformation,
      });
    }
  }, [thirdPartyInvolvedInformation]);

  useEffect(() => {
    console.log('state', state);
  }, [state]);

  const dataCollapse = () => {
    return formCollapse.map((item, index) => {
      return item;
    });
  };

  return (
    <div className="third_parties_involved_form">
      <div className="title">5. Terceros involucrados</div>

      <Form form={element_form} colon={false} autoComplete="off" name="dynamic_form_complex">
        <Row
          gutter={[24, 24]}
          style={{
            marginTop: '14px',
          }}
        >
          <Col sm={8} xs={24}>
            <Form.Item label="¿Autos y/o otros bienes involucrados?" name="propertyInvolved">
              <Radio.Group
                // defaultValue={radioPropertyInvolved}
                value={radioPropertyInvolved}
                onChange={onChangePropertyInvolved}
              >
                <Radio value={true}>Si</Radio>
                <Radio value={false}>No</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          {radioPropertyInvolved ? (
            <>
              <Col sm={8} xs={24}>
                <Form.Item label="¿Terceros con lesiones corporales?" name="peopleInjured">
                  <Radio.Group value={radioPeopleInjured} onChange={onChangePeopleInjured}>
                    <Radio value={true}>Si</Radio>
                    <Radio value={false}>No</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Col sm={8} xs={24}>
                <Form.Item label="¿Tiene información del terceros?" name="thirdPartyInformationAvailable">
                  <Radio.Group value={radioThirdPartyInformationAvailable} onChange={onChangeThirdPartyInformationAvailable}>
                    <Radio value={true}>Si</Radio>
                    <Radio value={false}>No</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
            </>
          ) : null}
        </Row>
      </Form>

      {radioPropertyInvolved && radioThirdPartyInformationAvailable && (
        <>
          <Divider />

          <div className="title">Agregar información del tercero involucrado</div>
          <div className="sub_title">Los campos marcados con el asterisco (*) son obligatorios.</div>

          {dataCollapse()}

          <Row
            gutter={[24, 24]}
            style={{
              width: '98%',
              marginBottom: '20px',
            }}
          >
            <Col
              sm={24}
              xs={24}
              lg={24}
              style={{
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <Button
                type="primary"
                className="btn_add"
                onClick={() => {
                  // setShowModal(true)
                  setFormCollapse([
                    ...formCollapse,
                    <FormColapse
                      key={formCollapse.length}
                      indicador={formCollapse.length}
                      thirdPartyInvolvedInformation={thirdPartyInvolvedInformation}
                      setThirdPartyInvolvedInformation={setThirdPartyInvolvedInformation}
                      // setIndicadorDeleted={setIndicadorDeleted}
                    />,
                  ]);
                }}
                icon={<PlusOutlined />}
              >
                Agregar otro tercero
              </Button>
            </Col>
          </Row>
        </>
      )}
    </div>
  );
};
